class FacebookController {
  constructor(User, $state, usSpinnerService) {
    "ngInject";
    this.name = 'facebook';
    this.User = User;
    this.$state = $state;
    this.usSpinnerService = usSpinnerService;
  }

  $onInit() {
    this.User.getUserSettings().$loaded().then((userSettings) => {
      this.userSettings = userSettings;
    });
  }

  connectFacebook() {
    this
      .User.connectFacebook()
      .then((response) => {
        let authURL = response.data ? response.data.authURL : ''
        window.location.assign(authURL);
      });
  }

  savePages() {
    this.loading = true;
    this.User.saveFacebookPage({
        pageId: this.selectedPage.id,
        pageAccessToken: this.selectedPage.access_token
      }).then(() => {
        return this.User.updateUserOnboarding({
          facebook: true
        });
      })
      .then(() => {
        this.loading = false;
        return this.$state.go('onboarding.twitter');
      })
      .catch((err) => {
        this.loading = false;
        console.log(err);
      })
  }

  skip() {
    return this.User.updateUserOnboarding({
      facebook: true
    }).then(() => {
      return this.$state.go('onboarding.twitter');
    });
  }

  getFacebookPages() {
    this.showSpinner = true;
    this
      .User
      .getFacebookPages()
      .then((response) => {
        this.showSpinner = false;
        this.pages = response.data.pages.data;
        this.selectedPage = this.pages[0];
      })
      .catch((err) => {
        this.showSpinner = false;
        console.log(err);
      });
  }

}

export default FacebookController;



// WEBPACK FOOTER //
// ./client/app/components/home/onboarding/facebook/facebook.controller.js